"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBankLoanInterested = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
function createBankLoanInterested(_a) {
    var data = _a.data;
    var variables = {
        data: data,
    };
    return {
        mutation: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      mutation createBankLoanInterested($data: BankLoanInterestedCreateInput!) {\n        createBankLoanInterested(data: $data) {\n          id\n          bank\n          name\n          phone\n          createAt\n          listingId\n          userId\n          price\n        }\n      }\n    "], ["\n      mutation createBankLoanInterested($data: BankLoanInterestedCreateInput!) {\n        createBankLoanInterested(data: $data) {\n          id\n          bank\n          name\n          phone\n          createAt\n          listingId\n          userId\n          price\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.createBankLoanInterested = createBankLoanInterested;
var templateObject_1;
